// src/features/business-functions/components/AccountTabBar.jsx
import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { colors, spacing } from '../../../theme/tokens';

/**
 * Dynamic config-driven tab bar for the Account Detail page.
 * Renders tabs from the tabConfig array — adding a new tab only requires
 * appending to ACCOUNT_TAB_CONFIG in constants.
 *
 * Optional `addAction` renders a trailing "+" control (e.g. create workspace table).
 */
export default function AccountTabBar({
  tabConfig,
  activeTab,
  onTabChange,
  styles,
  addAction,
}) {
  const handleTabChange = (event, newValue) => {
    if (newValue === '__add__') {
      addAction?.onClick?.();
      return;
    }
    onTabChange?.(event, newValue);
  };

  return (
    <Box sx={styles.tabBarRoot}>
      <Box sx={styles.tabBarInlineRow}>
        <Tabs
          value={activeTab || false}
          onChange={handleTabChange}
          TabIndicatorProps={{ sx: styles.tabBarIndicator }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
              ...(addAction ? styles.tabBarTabsInline : styles.tabBarTabs),

              '& .MuiTabScrollButton-root.Mui-disabled': {
                opacity: 1,
                color:colors.grey[500]
              },
              '& .MuiButtonBase-root.MuiTabScrollButton-root':{width:spacing.size20 + 5}
            }}
            >
          {tabConfig.map((tab) => (
            <Tab
              key={tab.key}
              value={tab.key}
              label={tab.label}
              sx={styles.tabItem}
              disableRipple
            />
          ))}

          {addAction ? (
            <Tab
              value="__add__"
              icon={<AddIcon sx={{ fontSize: 18 }} />}
              aria-label={addAction.label || 'Create table'}
              disabled={addAction.disabled}
              sx={styles.tabBarAddTab}
              disableRipple
            />
          ) : null}
        </Tabs>
      </Box>
    </Box>
  );
}
